module.exports = __webpack_public_path__ + "img/chembio_logo_dax.e5d6cce8.png";